/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable no-useless-catch */
import { API } from "../api";
import {
  AIR,
  FIRST_MILE,
  IN_BOUND,
  OUT_BOUND,
  LAST_MILE,
  RETURN,
  RVP,
  CARGO_IN_SCAN,
  CARGO_OUT_SCAN,
  CARGO_DEST_IN_SCAN,
} from "../constants/url.constant";
import { HANDED_OVER_TO_TPL_SCAN } from "../constants/url.constant";

export const UPDATE_ORDER_STATUS_REQUEST = "UPDATE_ORDER_STATUS_REQUEST";
export const UPDATE_ORDER_STATUS_SUCCESS = "UPDATE_ORDER_STATUS_SUCCESS";

export const updateOrderStatus = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${FIRST_MILE}/scan`, data);
      dispatch({
        type: UPDATE_ORDER_STATUS_SUCCESS
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateInScanStatus = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${IN_BOUND}/scan`, data);
      dispatch({
        type: UPDATE_ORDER_STATUS_SUCCESS
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updatePickupRejectStatus = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${FIRST_MILE}/scan/pickup/reject`, data);
      dispatch({
        type: UPDATE_ORDER_STATUS_SUCCESS
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updatePickupCancelledStatus = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${FIRST_MILE}/scan/pickup/cancelled`, data);
      dispatch({
        type: UPDATE_ORDER_STATUS_SUCCESS
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateArrangedForDeliveryStatus = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${AIR}/scan/arranged-for-delivery`, data);
      dispatch({
        type: UPDATE_ORDER_STATUS_SUCCESS
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateArrivedAtAirportStatus = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${AIR}/scan/arrived-at-airport`, data);
      dispatch({
        type: UPDATE_ORDER_STATUS_SUCCESS
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateDepartedFromAirportStatus = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${AIR}/scan/departed-from-airport`, data);
      dispatch({
        type: UPDATE_ORDER_STATUS_SUCCESS
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateFlightDelayedStatus = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${AIR}/scan/flight-delayed`, data);
      dispatch({
        type: UPDATE_ORDER_STATUS_SUCCESS
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};


export const updateDeliveryCancelledStatus = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${AIR}/scan/delivery-cancelled`, data);
      dispatch({
        type: UPDATE_ORDER_STATUS_SUCCESS
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};


export const updateDeliveryRejectedStatus = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${AIR}/scan/delivery-rejected`, data);
      dispatch({
        type: UPDATE_ORDER_STATUS_SUCCESS
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateOutScanStatus = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${OUT_BOUND}/scan`, data);
      dispatch({
        type: UPDATE_ORDER_STATUS_SUCCESS
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateRTHScanStatus = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${LAST_MILE}/scan`, data);
      dispatch({
        type: UPDATE_ORDER_STATUS_SUCCESS
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateDRSScanStatus = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${LAST_MILE}/drsscan`, data);
      dispatch({
        type: UPDATE_ORDER_STATUS_SUCCESS
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateRTHInScanStatus = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${RETURN}/rth-inscan`, data);
      dispatch({
        type: UPDATE_ORDER_STATUS_SUCCESS
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateRTHOutScanStatus = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${RETURN}/rth-outscan`, data);
      dispatch({
        type: UPDATE_ORDER_STATUS_SUCCESS
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateRTOHubScanStatus = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${RETURN}/rto-hubscan`, data);
      dispatch({
        type: UPDATE_ORDER_STATUS_SUCCESS
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateRTSScanStatus = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${RETURN}/rts-scan`, data);
      dispatch({
        type: UPDATE_ORDER_STATUS_SUCCESS
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateRVPInScanStatus = (data) => {
  return async (dispatch) => {
    dispatch({
      type: UPDATE_ORDER_STATUS_REQUEST
    });

    try {
      const res = await API.put(`${RVP}/in-scan`, data);
      dispatch({
        type: UPDATE_ORDER_STATUS_SUCCESS
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateRVPOutScanStatus = (data) => {
  return async (dispatch) => {
    dispatch({
      type: UPDATE_ORDER_STATUS_REQUEST
    });

    try {
      const res = await API.put(`${RVP}/out-scan`, data);
      dispatch({
        type: UPDATE_ORDER_STATUS_SUCCESS
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateLMInventoryScanStatus = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${LAST_MILE}/lm-inventory-scan`, data);
      dispatch({
        type: UPDATE_ORDER_STATUS_SUCCESS
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateRVPScanStatus = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${LAST_MILE}/ofp-scan`, data);
      dispatch({
        type: UPDATE_ORDER_STATUS_SUCCESS
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateHandedOverToTPLScanStatus = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${HANDED_OVER_TO_TPL_SCAN}`, data);
      dispatch({
        type: UPDATE_ORDER_STATUS_SUCCESS
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateOCInScanStatus = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(CARGO_IN_SCAN, data);
      dispatch({
        type: UPDATE_ORDER_STATUS_SUCCESS
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateOCOutScanStatus = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(CARGO_OUT_SCAN, data);
      dispatch({
        type: UPDATE_ORDER_STATUS_SUCCESS
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateOCDestInScanStatus = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(CARGO_DEST_IN_SCAN, data);
      dispatch({
        type: UPDATE_ORDER_STATUS_SUCCESS
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

const initialState = {
  isLoading: false,
  loaded: false
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case UPDATE_ORDER_STATUS_REQUEST:
      return {
        ...state,
        isLoading: true,
        loaded: false
      };
    case UPDATE_ORDER_STATUS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        loaded: true
      };
    default:
      return state;
  }
}
